import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import classnames from 'classnames';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import BiDiv from '@wix/da-bi/pkg/Components/BiDiv';
import { useTranslation } from 'react-i18next';
import ShareButton from './ShareButton';
import ShareIcon from './ShareIcon';
import socialShareButtonsStyle from './SocialShareButtons.scss';
export const SocialShareButton = ({ type, showName = false, disabled, iconShape = 'circle', iconSize = 32, iconBgColor, logoFillColor, windowWidth, windowHeight, beforeOnClick, onShareWindowClose, shareInfo, nameClassname, className, shareButtonClassname, biData })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(BiDiv, {
        biData: BiData(_object_spread_props(_object_spread({
            typeid: BiContextProvidedValue,
            itemid: BiContextProvidedValue
        }, biData), {
            evid: 356,
            social_share: type
        })),
        className: classnames(socialShareButtonsStyle['social-share-group'], className)
    }, /*#__PURE__*/ React.createElement(ShareButton, _object_spread({
        type: type,
        beforeOnClick: beforeOnClick,
        onShareWindowClose: onShareWindowClose,
        windowWidth: windowWidth,
        windowHeight: windowHeight,
        disabled: disabled
    }, shareInfo), /*#__PURE__*/ React.createElement("div", {
        className: classnames(socialShareButtonsStyle['social-share-button'], shareButtonClassname)
    }, /*#__PURE__*/ React.createElement(ShareIcon, {
        type: type,
        size: iconSize,
        round: iconShape === 'circle',
        bgStyle: {
            fill: iconBgColor
        },
        iconFillColor: logoFillColor
    }), showName && /*#__PURE__*/ React.createElement("span", {
        className: nameClassname
    }, t(`social.${type}`)))));
};
SocialShareButton.displayName = 'SocialShareButton';
export default SocialShareButton;
